"use client";

import dynamic from "next/dynamic";
import type { FormBlockProps } from "@/features/Blocks/FormBlock";

const FormBlock = dynamic(
  () => import("@/features/Blocks/FormBlock").then((mod) => mod.FormBlock),
  { ssr: false }
);

export function LazyFormBlock(props: FormBlockProps) {
  return <FormBlock {...props} />;
}
